import trackError from '@helpers/trackError'
import { Carrier, Carriers, ReboundPostalServices } from '../types'
import { ZReturnsCarriersValidator } from '../validators/returnSchema'
import { ZRebountPostalServiceValidator } from '../validators/reboundApiSchema'
import { formatZodError } from './zodErrorFormatter'

function sortCarriersWithRoyalMailFirst(carriers: Carriers) {
  return [...carriers].sort((a, b) => {
    const aIsRoyal = a.title?.toLowerCase().includes('royal mail')
    const bIsRoyal = b.title?.toLowerCase().includes('royal mail')

    // Royal Mail goes first
    if (aIsRoyal && !bIsRoyal) return -1
    if (!aIsRoyal && bIsRoyal) return 1
    return 0
  })
}

export async function buildLegacyCarriers(
  postalServices: ReboundPostalServices[]
): Promise<Carriers> {
  const validatedInput =
    ZRebountPostalServiceValidator.safeParse(postalServices)

  if (!validatedInput.success) {
    const formatted = formatZodError(validatedInput.error, postalServices)
    console.error('Zod validation failed for Carriers:\n' + formatted)

    trackError(new Error('Zod validation failed for carriers'), {
      details: formatted,
      section: 'Returns'
    })

    throw new Error('Invalid Carriers data. See logs for details.')
  }

  const mapped: Carriers = validatedInput.data.map(
    (service): Carrier => ({
      id: Number(service.id) || 0,
      title: service.title,
      byline: service.byline ?? '',
      message: service.message,
      modal_title: service.modal_title,
      modal_byline: service.modal_byline,
      modal_message: service.modal_message
    })
  )

  const validatedOutput = ZReturnsCarriersValidator.safeParse(mapped)
  if (!validatedOutput.success) {
    const formatted = formatZodError(validatedOutput.error, mapped)
    console.error('Zod validation failed for Carriers (mapped):\n' + formatted)
    trackError(new Error('Zod validation failed for carriers (mapped)'), {
      details: formatted,
      section: 'Returns'
    })
    throw new Error('Invalid Carriers after mapping. See logs for details.')
  }

  return sortCarriersWithRoyalMailFirst(validatedOutput.data)
}
